/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description: 学习进度
 * @Date: 2021-01-08 14:32:28
 * @LastEditTime: 2021-01-12 16:34:34
 * @FilePath: /yft-b2c-web-h5/src/pages/Learn/My/Progress/ProgressServ.js
 */
import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取列表
   */
  static getList(params, apiInfo) {
    console.log(apiInfo);
    return request({
      url: apiInfo.url,
      host: config[apiInfo.host],
      method: apiInfo.method ? apiInfo.method : 'post_json',
      ...(apiInfo.isQuery
        ? { params, data: apiInfo.bodyP ? { ...apiInfo.bodyP } : {} }
        : { [apiInfo.method ? 'params' : 'data']: params })
    });
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/InfiniteScrollByAntd/indexServ.js